/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  GeolocationModelBody,
  SegmentCarModel,
  TransportAssignmentModel,
  TransportSegmentModel,
  TransportSegmentsCompleteSegmentParams,
  TransportSegmentsGenerateSegmentsFromRouteParams,
  TransportSegmentsGetSegmentParams,
  TransportSegmentsGetSegmentsForTruckAssignmentParams,
  TransportSegmentsStartSegmentParams,
  TransportSegmentsUpdateSegmentCarLoadingStatusParams,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useTransportSegmentsGenerateSegmentsFromRouteHook = () => {
  const transportSegmentsGenerateSegmentsFromRoute =
    useCustomInstance<TransportSegmentModel[]>();

  return useCallback(
    (
      transportAssignmentModel: TransportAssignmentModel[],
      params?: TransportSegmentsGenerateSegmentsFromRouteParams
    ) => {
      return transportSegmentsGenerateSegmentsFromRoute({
        url: `/api/TransportSegments/GenerateSegmentsFromRoute`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: transportAssignmentModel,
        params,
      });
    },
    [transportSegmentsGenerateSegmentsFromRoute]
  );
};

export const useTransportSegmentsGenerateSegmentsFromRouteMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportSegmentsGenerateSegmentsFromRouteHook>
      >
    >,
    TError,
    {
      data: TransportAssignmentModel[];
      params?: TransportSegmentsGenerateSegmentsFromRouteParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useTransportSegmentsGenerateSegmentsFromRouteHook>
    >
  >,
  TError,
  {
    data: TransportAssignmentModel[];
    params?: TransportSegmentsGenerateSegmentsFromRouteParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const transportSegmentsGenerateSegmentsFromRoute =
    useTransportSegmentsGenerateSegmentsFromRouteHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportSegmentsGenerateSegmentsFromRouteHook>
      >
    >,
    {
      data: TransportAssignmentModel[];
      params?: TransportSegmentsGenerateSegmentsFromRouteParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return transportSegmentsGenerateSegmentsFromRoute(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransportSegmentsGenerateSegmentsFromRouteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportSegmentsGenerateSegmentsFromRouteHook>
      >
    >
  >;
export type TransportSegmentsGenerateSegmentsFromRouteMutationBody =
  TransportAssignmentModel[];
export type TransportSegmentsGenerateSegmentsFromRouteMutationError = unknown;

export const useTransportSegmentsGenerateSegmentsFromRoute = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportSegmentsGenerateSegmentsFromRouteHook>
      >
    >,
    TError,
    {
      data: TransportAssignmentModel[];
      params?: TransportSegmentsGenerateSegmentsFromRouteParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useTransportSegmentsGenerateSegmentsFromRouteHook>
    >
  >,
  TError,
  {
    data: TransportAssignmentModel[];
    params?: TransportSegmentsGenerateSegmentsFromRouteParams;
  },
  TContext
> => {
  const mutationOptions =
    useTransportSegmentsGenerateSegmentsFromRouteMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useTransportSegmentsGetSegmentHook = () => {
  const transportSegmentsGetSegment =
    useCustomInstance<TransportSegmentModel>();

  return useCallback(
    (params?: TransportSegmentsGetSegmentParams, signal?: AbortSignal) => {
      return transportSegmentsGetSegment({
        url: `/api/TransportSegments/GetSegment`,
        method: 'GET',
        params,
        signal,
      });
    },
    [transportSegmentsGetSegment]
  );
};

export const getTransportSegmentsGetSegmentQueryKey = (
  params?: TransportSegmentsGetSegmentParams
) => {
  return [
    `/api/TransportSegments/GetSegment`,
    ...(params ? [params] : []),
  ] as const;
};

export const useTransportSegmentsGetSegmentQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useTransportSegmentsGetSegmentHook>>
  >,
  TError = unknown,
>(
  params?: TransportSegmentsGetSegmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useTransportSegmentsGetSegmentHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTransportSegmentsGetSegmentQueryKey(params);

  const transportSegmentsGetSegment = useTransportSegmentsGetSegmentHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useTransportSegmentsGetSegmentHook>>>
  > = ({ signal }) => transportSegmentsGetSegment(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTransportSegmentsGetSegmentHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TransportSegmentsGetSegmentQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTransportSegmentsGetSegmentHook>>>
>;
export type TransportSegmentsGetSegmentQueryError = unknown;

export const useTransportSegmentsGetSegment = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useTransportSegmentsGetSegmentHook>>
  >,
  TError = unknown,
>(
  params?: TransportSegmentsGetSegmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useTransportSegmentsGetSegmentHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useTransportSegmentsGetSegmentQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportSegmentsGetSegmentsForTruckAssignmentHook = () => {
  const transportSegmentsGetSegmentsForTruckAssignment =
    useCustomInstance<TransportSegmentModel[]>();

  return useCallback(
    (
      params?: TransportSegmentsGetSegmentsForTruckAssignmentParams,
      signal?: AbortSignal
    ) => {
      return transportSegmentsGetSegmentsForTruckAssignment({
        url: `/api/TransportSegments/GetSegmentsForTruckAssignment`,
        method: 'GET',
        params,
        signal,
      });
    },
    [transportSegmentsGetSegmentsForTruckAssignment]
  );
};

export const getTransportSegmentsGetSegmentsForTruckAssignmentQueryKey = (
  params?: TransportSegmentsGetSegmentsForTruckAssignmentParams
) => {
  return [
    `/api/TransportSegments/GetSegmentsForTruckAssignment`,
    ...(params ? [params] : []),
  ] as const;
};

export const useTransportSegmentsGetSegmentsForTruckAssignmentQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportSegmentsGetSegmentsForTruckAssignmentHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportSegmentsGetSegmentsForTruckAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportSegmentsGetSegmentsForTruckAssignmentHook
          >
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTransportSegmentsGetSegmentsForTruckAssignmentQueryKey(params);

  const transportSegmentsGetSegmentsForTruckAssignment =
    useTransportSegmentsGetSegmentsForTruckAssignmentHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportSegmentsGetSegmentsForTruckAssignmentHook>
      >
    >
  > = ({ signal }) =>
    transportSegmentsGetSegmentsForTruckAssignment(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportSegmentsGetSegmentsForTruckAssignmentHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TransportSegmentsGetSegmentsForTruckAssignmentQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportSegmentsGetSegmentsForTruckAssignmentHook>
      >
    >
  >;
export type TransportSegmentsGetSegmentsForTruckAssignmentQueryError = unknown;

export const useTransportSegmentsGetSegmentsForTruckAssignment = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportSegmentsGetSegmentsForTruckAssignmentHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportSegmentsGetSegmentsForTruckAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportSegmentsGetSegmentsForTruckAssignmentHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportSegmentsGetSegmentsForTruckAssignmentQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportSegmentsUpdateSegmentHook = () => {
  const transportSegmentsUpdateSegment =
    useCustomInstance<TransportSegmentModel>();

  return useCallback(
    (transportSegmentModel: TransportSegmentModel) => {
      return transportSegmentsUpdateSegment({
        url: `/api/TransportSegments/UpdateSegment`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: transportSegmentModel,
      });
    },
    [transportSegmentsUpdateSegment]
  );
};

export const useTransportSegmentsUpdateSegmentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useTransportSegmentsUpdateSegmentHook>>
    >,
    TError,
    { data: TransportSegmentModel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useTransportSegmentsUpdateSegmentHook>>>,
  TError,
  { data: TransportSegmentModel },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const transportSegmentsUpdateSegment =
    useTransportSegmentsUpdateSegmentHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useTransportSegmentsUpdateSegmentHook>>
    >,
    { data: TransportSegmentModel }
  > = (props) => {
    const { data } = props ?? {};

    return transportSegmentsUpdateSegment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransportSegmentsUpdateSegmentMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTransportSegmentsUpdateSegmentHook>>>
>;
export type TransportSegmentsUpdateSegmentMutationBody = TransportSegmentModel;
export type TransportSegmentsUpdateSegmentMutationError = unknown;

export const useTransportSegmentsUpdateSegment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useTransportSegmentsUpdateSegmentHook>>
    >,
    TError,
    { data: TransportSegmentModel },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useTransportSegmentsUpdateSegmentHook>>>,
  TError,
  { data: TransportSegmentModel },
  TContext
> => {
  const mutationOptions =
    useTransportSegmentsUpdateSegmentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useTransportSegmentsUpdateSegmentOrderHook = () => {
  const transportSegmentsUpdateSegmentOrder =
    useCustomInstance<TransportSegmentModel[]>();

  return useCallback(
    (transportSegmentModel: TransportSegmentModel[]) => {
      return transportSegmentsUpdateSegmentOrder({
        url: `/api/TransportSegments/UpdateSegmentOrder`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: transportSegmentModel,
      });
    },
    [transportSegmentsUpdateSegmentOrder]
  );
};

export const useTransportSegmentsUpdateSegmentOrderMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useTransportSegmentsUpdateSegmentOrderHook>>
    >,
    TError,
    { data: TransportSegmentModel[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useTransportSegmentsUpdateSegmentOrderHook>>
  >,
  TError,
  { data: TransportSegmentModel[] },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const transportSegmentsUpdateSegmentOrder =
    useTransportSegmentsUpdateSegmentOrderHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useTransportSegmentsUpdateSegmentOrderHook>>
    >,
    { data: TransportSegmentModel[] }
  > = (props) => {
    const { data } = props ?? {};

    return transportSegmentsUpdateSegmentOrder(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransportSegmentsUpdateSegmentOrderMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useTransportSegmentsUpdateSegmentOrderHook>>
  >
>;
export type TransportSegmentsUpdateSegmentOrderMutationBody =
  TransportSegmentModel[];
export type TransportSegmentsUpdateSegmentOrderMutationError = unknown;

export const useTransportSegmentsUpdateSegmentOrder = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useTransportSegmentsUpdateSegmentOrderHook>>
    >,
    TError,
    { data: TransportSegmentModel[] },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useTransportSegmentsUpdateSegmentOrderHook>>
  >,
  TError,
  { data: TransportSegmentModel[] },
  TContext
> => {
  const mutationOptions =
    useTransportSegmentsUpdateSegmentOrderMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useTransportSegmentsStartSegmentHook = () => {
  const transportSegmentsStartSegment =
    useCustomInstance<TransportSegmentModel>();

  return useCallback(
    (
      geolocationModelBody: GeolocationModelBody,
      params?: TransportSegmentsStartSegmentParams
    ) => {
      return transportSegmentsStartSegment({
        url: `/api/TransportSegments/StartSegment`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: geolocationModelBody,
        params,
      });
    },
    [transportSegmentsStartSegment]
  );
};

export const useTransportSegmentsStartSegmentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useTransportSegmentsStartSegmentHook>>
    >,
    TError,
    {
      data: GeolocationModelBody;
      params?: TransportSegmentsStartSegmentParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useTransportSegmentsStartSegmentHook>>>,
  TError,
  { data: GeolocationModelBody; params?: TransportSegmentsStartSegmentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const transportSegmentsStartSegment = useTransportSegmentsStartSegmentHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useTransportSegmentsStartSegmentHook>>
    >,
    { data: GeolocationModelBody; params?: TransportSegmentsStartSegmentParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return transportSegmentsStartSegment(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransportSegmentsStartSegmentMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTransportSegmentsStartSegmentHook>>>
>;
export type TransportSegmentsStartSegmentMutationBody = GeolocationModelBody;
export type TransportSegmentsStartSegmentMutationError = unknown;

export const useTransportSegmentsStartSegment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useTransportSegmentsStartSegmentHook>>
    >,
    TError,
    {
      data: GeolocationModelBody;
      params?: TransportSegmentsStartSegmentParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useTransportSegmentsStartSegmentHook>>>,
  TError,
  { data: GeolocationModelBody; params?: TransportSegmentsStartSegmentParams },
  TContext
> => {
  const mutationOptions =
    useTransportSegmentsStartSegmentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useTransportSegmentsCompleteSegmentHook = () => {
  const transportSegmentsCompleteSegment =
    useCustomInstance<TransportSegmentModel>();

  return useCallback(
    (
      geolocationModelBody: GeolocationModelBody,
      params?: TransportSegmentsCompleteSegmentParams
    ) => {
      return transportSegmentsCompleteSegment({
        url: `/api/TransportSegments/CompleteSegment`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: geolocationModelBody,
        params,
      });
    },
    [transportSegmentsCompleteSegment]
  );
};

export const useTransportSegmentsCompleteSegmentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useTransportSegmentsCompleteSegmentHook>>
    >,
    TError,
    {
      data: GeolocationModelBody;
      params?: TransportSegmentsCompleteSegmentParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useTransportSegmentsCompleteSegmentHook>>
  >,
  TError,
  {
    data: GeolocationModelBody;
    params?: TransportSegmentsCompleteSegmentParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const transportSegmentsCompleteSegment =
    useTransportSegmentsCompleteSegmentHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useTransportSegmentsCompleteSegmentHook>>
    >,
    {
      data: GeolocationModelBody;
      params?: TransportSegmentsCompleteSegmentParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return transportSegmentsCompleteSegment(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransportSegmentsCompleteSegmentMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useTransportSegmentsCompleteSegmentHook>>
  >
>;
export type TransportSegmentsCompleteSegmentMutationBody = GeolocationModelBody;
export type TransportSegmentsCompleteSegmentMutationError = unknown;

export const useTransportSegmentsCompleteSegment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useTransportSegmentsCompleteSegmentHook>>
    >,
    TError,
    {
      data: GeolocationModelBody;
      params?: TransportSegmentsCompleteSegmentParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useTransportSegmentsCompleteSegmentHook>>
  >,
  TError,
  {
    data: GeolocationModelBody;
    params?: TransportSegmentsCompleteSegmentParams;
  },
  TContext
> => {
  const mutationOptions =
    useTransportSegmentsCompleteSegmentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useTransportSegmentsUpdateSegmentCarLoadingStatusHook = () => {
  const transportSegmentsUpdateSegmentCarLoadingStatus =
    useCustomInstance<SegmentCarModel>();

  return useCallback(
    (
      geolocationModelBody: GeolocationModelBody,
      params?: TransportSegmentsUpdateSegmentCarLoadingStatusParams
    ) => {
      return transportSegmentsUpdateSegmentCarLoadingStatus({
        url: `/api/TransportSegments/UpdateSegmentCarLoadingStatus`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: geolocationModelBody,
        params,
      });
    },
    [transportSegmentsUpdateSegmentCarLoadingStatus]
  );
};

export const useTransportSegmentsUpdateSegmentCarLoadingStatusMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportSegmentsUpdateSegmentCarLoadingStatusHook
          >
        >
      >,
      TError,
      {
        data: GeolocationModelBody;
        params?: TransportSegmentsUpdateSegmentCarLoadingStatusParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportSegmentsUpdateSegmentCarLoadingStatusHook>
      >
    >,
    TError,
    {
      data: GeolocationModelBody;
      params?: TransportSegmentsUpdateSegmentCarLoadingStatusParams;
    },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const transportSegmentsUpdateSegmentCarLoadingStatus =
      useTransportSegmentsUpdateSegmentCarLoadingStatusHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportSegmentsUpdateSegmentCarLoadingStatusHook
          >
        >
      >,
      {
        data: GeolocationModelBody;
        params?: TransportSegmentsUpdateSegmentCarLoadingStatusParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return transportSegmentsUpdateSegmentCarLoadingStatus(data, params);
    };

    return { mutationFn, ...mutationOptions };
  };

export type TransportSegmentsUpdateSegmentCarLoadingStatusMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportSegmentsUpdateSegmentCarLoadingStatusHook>
      >
    >
  >;
export type TransportSegmentsUpdateSegmentCarLoadingStatusMutationBody =
  GeolocationModelBody;
export type TransportSegmentsUpdateSegmentCarLoadingStatusMutationError =
  unknown;

export const useTransportSegmentsUpdateSegmentCarLoadingStatus = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportSegmentsUpdateSegmentCarLoadingStatusHook>
      >
    >,
    TError,
    {
      data: GeolocationModelBody;
      params?: TransportSegmentsUpdateSegmentCarLoadingStatusParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useTransportSegmentsUpdateSegmentCarLoadingStatusHook>
    >
  >,
  TError,
  {
    data: GeolocationModelBody;
    params?: TransportSegmentsUpdateSegmentCarLoadingStatusParams;
  },
  TContext
> => {
  const mutationOptions =
    useTransportSegmentsUpdateSegmentCarLoadingStatusMutationOptions(options);

  return useMutation(mutationOptions);
};
